import { IconsProps } from '@/types/shared'
import React from 'react'

const QuestionIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.5 4V11H5.67L5.08 11.59L4.5 12.17V4H15.5ZM16.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V17L6.5 13H16.5C16.7652 13 17.0196 12.8946 17.2071 12.7071C17.3946 12.5196 17.5 12.2652 17.5 12V3C17.5 2.73478 17.3946 2.48043 17.2071 2.29289C17.0196 2.10536 16.7652 2 16.5 2ZM21.5 6H19.5V15H6.5V17C6.5 17.2652 6.60536 17.5196 6.79289 17.7071C6.98043 17.8946 7.23478 18 7.5 18H18.5L22.5 22V7C22.5 6.73478 22.3946 6.48043 22.2071 6.29289C22.0196 6.10536 21.7652 6 21.5 6Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default QuestionIcons
